<template>
    <div class="retr__row" :class="{ active: isExpanded }">
        <div class="retr__row-header expandable" @click="toggle">
            <div class="retr__label">
                <slot name="label" :is-expanded="isExpanded" />
            </div>

            <div class="retr__value">
                <slot name="value" :is-expanded="isExpanded" />
            </div>

            <div class="retr__options">
                <slot name="expand-button" :is-expanded="isExpanded">
                    <span class="text-sm retr__expand-text">
                        {{ isExpanded ? 'Zwiń' : 'Rozwiń' }}
                    </span>
                    <a-icon
                        class="retr__chevron"
                        icon="Chevron"
                    />
                </slot>
            </div>
        </div>

        <transition-slide>
            <div v-if="isExpanded">
                <slot name="content" :is-expanded="isExpanded" />
            </div>
        </transition-slide>
    </div>
</template>

<script>
export default {
    name: 'RetrCurrentSingleTableRow',

    props: {
        defaultExpanded: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isExpanded: this.defaultExpanded
        }
    },

    methods: {
        toggle() {
            this.isExpanded = !this.isExpanded
            this.$emit('toggle', this.isExpanded)
        },

        expand() {
            this.isExpanded = true
            this.$emit('toggle', this.isExpanded)
        },

        collapse() {
            this.isExpanded = false
            this.$emit('toggle', this.isExpanded)
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/components/retr-common';
</style>
